"use client";

import { c as _c } from "react/compiler-runtime";
import { AerodromeLogo, MeteoraLogo, OpenSeaBrandLogo, OrcaLogo, PancakeLogo, PumpfunLogo, RaydiumLogo, SolfiLogo, UniswapLogo } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
export const useSwapProtocols = () => {
  const $ = _c(4);
  const t = useTranslations("useSwapProtocols");
  let t0;
  if ($[0] !== t) {
    t0 = identifier => {
      switch (identifier) {
        case "all":
          {
            return t("all");
          }
        case "orca":
          {
            return t("orca");
          }
        case "raydium":
          {
            return t("raydium");
          }
        case "uniswap":
          {
            return t("uniswap");
          }
        case "pancake_swap":
          {
            return t("pancake_swap");
          }
        case "aerodrome":
          {
            return t("aerodrome");
          }
        case "pumpfun":
          {
            return t("pumpfun");
          }
        case "meteora":
          {
            return t("meteora");
          }
        case "opensea":
          {
            return t("opensea");
          }
        case "solfi":
          {
            return t("solfi");
          }
        default:
          {
            return identifier ?? "";
          }
      }
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getName = t0;
  const getLogo = _temp;
  let t1;
  if ($[2] !== getName) {
    t1 = {
      getLogo,
      getName
    };
    $[2] = getName;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(identifier_0) {
  switch (identifier_0) {
    case "all":
      {
        return {};
      }
    case "orca":
      {
        return {
          icon: OrcaLogo
        };
      }
    case "raydium":
      {
        return {
          icon: RaydiumLogo
        };
      }
    case "uniswap":
      {
        return {
          icon: UniswapLogo
        };
      }
    case "pancake_swap":
      {
        return {
          icon: PancakeLogo
        };
      }
    case "aerodrome":
      {
        return {
          icon: AerodromeLogo
        };
      }
    case "pumpfun":
      {
        return {
          icon: PumpfunLogo
        };
      }
    case "meteora":
      {
        return {
          icon: MeteoraLogo
        };
      }
    case "opensea":
      {
        return {
          icon: OpenSeaBrandLogo
        };
      }
    case "solfi":
      {
        return {
          icon: SolfiLogo
        };
      }
    default:
      {
        return {};
      }
  }
}